module.exports = __webpack_public_path__ + "static/2-7e44b6760d523976c7f61086c38583ef.jpg";